import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import Script from 'react-load-script';
import { LOCAL_STORAGE_KEYS } from '../../../global/const';

const FormikPlaceSearch = (props) => {
  const [locality, setLocality] = useState('');
  let googleSearch = useRef();
  let autocomplete;

  const handleScriptLoad = () => {
    let options = {
      types: ['(cities)'],
    };
    // const node = .current;
    /*global google*/ // To disable any eslint 'google not defined' errors
    autocomplete = new google.maps.places.Autocomplete(googleSearch, options);
    autocomplete.addListener('place_changed', handlePlaceSelect);
  };

  const handlePlaceSelect = () => {
    let addressObject = autocomplete.getPlace();
    let address = addressObject.address_components;

    if (address) {
      const lat = addressObject.geometry.location.lat();
      const lng = addressObject.geometry.location.lng();

      setLocality(addressObject.formatted_address);

      let fullAddress = {
        latitude: lat,
        longitude: lng,
        city: '',
        state: '',
        country: '',
        zipcode: '',
        address: addressObject.formatted_address,
      };
      for (let result of address) {
        if (result.types.indexOf('locality') > -1 && result.types.indexOf('political') > -1) {
          fullAddress.city = result.long_name;
        } else if (result.types.indexOf('administrative_area_level_1') > -1 && result.types.indexOf('political') > -1) {
          fullAddress.state = result.long_name;
        } else if (result.types.indexOf('country') > -1 && result.types.indexOf('political') > -1) {
          fullAddress.country = result.long_name;
        } else if (result.types.indexOf('postal_code') > -1 && result.types.indexOf('postal_code') > -1) {
          fullAddress.zipcode = result.long_name;
        }
      }
      localStorage.setItem(LOCAL_STORAGE_KEYS.LOCATION, JSON.stringify(fullAddress));
      props.onChange(locality);
    }
  };

  const handleChange = (e) => {
    setLocality(e.target.value);
  };

  const { label, error, placeholder, labelClasses, size, value, className } = props;
  const classes = classnames(
    'form-control',
    {
      'is-invalid': !!error,
    },
    className,
  );
  const LabelClasses = classnames('form-label', labelClasses);
  const FormGroupClasses = classnames('form-group', size);
  return (
    <div className={FormGroupClasses}>
      <label className={LabelClasses}>{label}</label>
      <input
        className={classes}
        placeholder={placeholder}
        ref={(el) => (googleSearch = el)}
        value={locality ? locality : value}
        onFocus={(e) => e.target.select()}
        onChange={handleChange}
      />
      {error && <div className="invalid-feedback">{error}</div>}
      <Script url="https://maps.googleapis.com/maps/api/js?key=AIzaSyAfPK2JvZ_Y5Jc1lq-DFFxPKHkY3nOxNYk&libraries=places" onLoad={handleScriptLoad} />
    </div>
  );
};

export default FormikPlaceSearch;
